import React from 'react'

function DashBoard() {
    return (
        <div style={{
            position: "absolute",
            backgroundColor: "red"
        }}>
            DashBoard
        </div>
    )
}

export default DashBoard